import React from "react";
import MobileApp from "../components/MobileApp/MobileApp";

export default function MobileAppDevelopmentPage() {
    return (
        <main>
            <MobileApp />
        </main>
    );
}
